import React, { useEffect } from "react";
import ApexCharts from "apexcharts";

const classes = {
    chartContainer: {
        height: "220px",
    },
};

export default function PercentGauge(props) {
    useEffect(() => {
        const options = getOptions(props.percent);
        const chart = new ApexCharts(document.querySelector(`#chart${props.device}`), options);
        chart.render();
    }, []);

    return <div id={`chart${props.device}`} sx={classes.chartContainer}></div>;
}
const getOptions = (percent) => {
    return {
        chart: {
            width: "100%",
            height: "100%",
            type: "radialBar",
        },
        series: [percent === "NaN" ? 0 : percent],
        plotOptions: {
            radialBar: {
                track: {
                    background: "#EA6A47",
                    dropShadow: {
                        enabled: true,
                        top: 2,
                        left: 0,
                        blur: 4,
                        opacity: 0.15,
                    },
                },
                hollow: {
                    margin: 15,
                    size: "70%",
                },
                dataLabels: {
                    name: {
                        offsetY: 30,
                        show: true,
                        color: "#7E909A",
                        fontSize: "15px",
                    },
                    value: {
                        color: "#1C4E80",
                        offsetY: -5,
                        fontSize: "30px",
                        show: true,
                    },
                },
            },
        },
        tooltip: {
            enabled: true,
            followCursor: false,
            title: "hi",
            style: {
                fontSize: "18px",
            },
            fixed: {
                enabled: false,
                position: "topRight",
                offsetY: 0,
                offsetX: 0,
            },
            custom: function () {
                return `Online: ${percent === "NaN" ? 0 : percent}%\r\nOffline: ${
                    percent === "NaN" ? 0 : 100 - percent
                }%`;
            },
        },
        fill: {
            type: "solid",
            colors: ["#A5D8DD"],
        },
        labels: ["online"],
    };
};
